import { useEffect } from "react";
import { useLocation } from "wouter";

/** Il bootstrap globale invia la prima visita; deduplica gli effetti React. */
export function MetaPixelTracker() {
  const [location] = useLocation();
  useEffect(() => {
    window.__uoMetaPageView?.();
  }, [location]);
  return null;
}